/* Fardo.cl - Capa B2B de las cajas de precio por volumen.
   Estilos: snippets/fardo-tier-headline.liquid
   Markup base y logica de precios: tier-price-cards.liquid + fardo-tier-cards.js

   Agrega cuatro cosas al grid existente:
     1. El encabezado "Precios por volumen".
     2. Un icono con tantos cubos como sacos tiene el tramo (1, 3, 5, 10...).
     3. La linea de kilos aproximados por tramo (si el titulo declara kg).
     4. La marca "Mas conveniente" en el mejor tramo disponible.
*/
(function () {
  var KG = null;

  var TONE_COLOR = {
    a: '%2334497A',
    b: '%2334497A',
    c: '%2324386A',
    d: '%23FFFFFF'
  };

  (function readKg() {
    var title = String(window.FARDO_PRODUCT_TITLE || '');
    var m = title.match(/(\d+(?:[.,]\d+)?)\s*(?:kgs?|kilos?|kilogramos?)\b/i);
    if (m) {
      var n = parseFloat(m[1].replace(',', '.'));
      if (!isNaN(n) && n > 0) KG = n;
    }
  })();

  function round1(v) {
    return Math.round(v * 10) / 10;
  }

  function kgNumber(value) {
    var v = round1(value);
    return (v % 1 === 0) ? String(v) : String(v).replace('.', ',');
  }

  /* Dibuja N cubos en dos filas (abajo la fila mas larga), dentro de un
     lienzo fijo de 44x26 para que todas las cajas alineen igual. */
  function cubesIcon(count, color) {
    var n = Math.max(1, Math.min(14, count));
    var bottom = Math.ceil(n / 2);
    var top = n - bottom;

    var size, gap;
    if (n === 1) {
      size = 18;
      gap = 0;
    } else {
      size = Math.min(9.5, 42 / (bottom + 0.22 * (bottom - 1)));
      gap = size * 0.22;
    }

    var blockHeight = (top > 0) ? (2 * size + gap) : size;
    var y0 = (26 - blockHeight) / 2;
    var stroke = (size >= 9) ? 1.5 : 1.3;
    var radius = round1(size * 0.22);
    var parts = [];

    function row(cells, y) {
      if (!cells) return;
      var width = cells * size + (cells - 1) * gap;
      var x0 = (44 - width) / 2;
      for (var i = 0; i < cells; i++) {
        parts.push(
          "<rect x='" + round1(x0 + i * (size + gap)) + "' y='" + round1(y) +
          "' width='" + round1(size) + "' height='" + round1(size) +
          "' rx='" + radius + "'/>"
        );
      }
    }

    row(top, y0);
    row(bottom, (top > 0) ? (y0 + size + gap) : y0);

    return "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 44 26' fill='none' stroke='" +
      color + "' stroke-width='" + stroke + "' stroke-linejoin='round'>" +
      parts.join('') + "</svg>";
  }

  function addIcons(container) {
    container.querySelectorAll('[data-tier]').forEach(function (card) {
      var qty = parseInt(card.getAttribute('data-qty'), 10);
      if (!qty) return;
      var color = TONE_COLOR[card.getAttribute('data-tone')] || TONE_COLOR.a;
      var value = 'url("data:image/svg+xml;utf8,' + cubesIcon(qty, color) + '")';
      if (card.style.getPropertyValue('--tier-icon') !== value) {
        card.style.setProperty('--tier-icon', value);
      }
    });
  }

  function addHeader(container) {
    if (container.querySelector('[data-fardo-tier-head]')) return;
    var el = document.createElement('div');
    el.className = 'fardo-tier-head';
    el.setAttribute('data-fardo-tier-head', '');
    el.innerHTML =
      '<span class="fardo-tier-head__main">' +
        '<span class="fardo-tier-head__icon" aria-hidden="true"></span>' +
        '<span class="fardo-tier-head__text">' +
          '<span class="fardo-tier-head__title">Precios por volumen</span>' +
          '<span class="fardo-tier-head__sub">A mayor cantidad, mayor descuento</span>' +
        '</span>' +
      '</span>' +
      '<span class="fardo-tier-head__pill">Ahorra más y haz crecer tu negocio</span>';
    container.insertBefore(el, container.firstChild);
  }

  function addKgLines(container) {
    if (KG == null) return;
    container.querySelectorAll('[data-tier]').forEach(function (card) {
      var qty = parseInt(card.getAttribute('data-qty'), 10);
      if (!qty) return;

      var el = card.querySelector('[data-fardo-kg]');
      if (!el) {
        el = document.createElement('span');
        el.className = 'fardo-tier-card__kg';
        el.setAttribute('data-fardo-kg', '');
        card.appendChild(el);
      }

      var label = card.querySelector('.fardo-tier-card__qty');
      var openEnded = !!(label && label.textContent.indexOf('+') > -1);
      var text = kgNumber(KG * qty) + (openEnded ? '+' : '') + ' kg aprox.';
      if (el.textContent !== text) el.textContent = text;
    });
  }

  /* El tramo con mayor cantidad que siga visible y con descuento. */
  function markBest(container) {
    var cards = Array.prototype.slice.call(container.querySelectorAll('[data-tier]'));
    var best = null;
    cards.forEach(function (card) {
      if (card.hidden) return;
      var discount = parseInt(card.getAttribute('data-discount'), 10) || 0;
      var qty = parseInt(card.getAttribute('data-qty'), 10) || 0;
      if (discount > 0 && (best === null || qty > best.qty)) best = { el: card, qty: qty };
    });
    cards.forEach(function (card) {
      var on = !!(best && card === best.el);
      if (card.classList.contains('is-best') !== on) card.classList.toggle('is-best', on);
    });
  }

  function apply() {
    document.querySelectorAll('[data-tier-cards]').forEach(function (container) {
      addHeader(container);
      addIcons(container);
      addKgLines(container);
      markBest(container);
    });
  }

  function boot() {
    apply();
    document.querySelectorAll('[data-tier-cards]').forEach(function (container) {
      if (container.__fardoB2bWatched) return;
      container.__fardoB2bWatched = true;
      new MutationObserver(function () {
        clearTimeout(window.__fardoTierB2bTimer);
        window.__fardoTierB2bTimer = setTimeout(apply, 70);
      }).observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 900);
  setTimeout(boot, 2200);
})();